import React, { useCallback, useMemo, useState } from "react";
import {
  Button,
  ButtonBase,
  CircularProgress,
  Dialog,
  DialogContent,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./Style.module.css";
import File from "../../../../../components/FileComponent/FileComponent.component";
import useUploadCsvDialogHook from "./UploadCsvDialog.hook";
import LogUtils from "../../../../../libs/LogUtils";
import { PrimaryButton } from "../../../../../components/Buttons/PrimaryButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UploadCsvDialog = ({ isOpen, handleToggle, handleCsvUpload }) => {
  const {
    changeTextData,
    errorData,
    form,
    handleSubmit,
    onBlurHandler,
    removeError,
    resData,
    isSubmitted,
    isSubmitting,
    isVerified,
  } = useUploadCsvDialogHook({ isOpen, handleCsvUpload, handleToggle });

  const renderTable = useMemo(() => {
    if (resData.length === 0) return "Success";
    return (
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell align="right">Required Data</TableCell>
              <TableCell align="right">Lookup Fail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {resData.map((row) => (
              <TableRow key={row.name}>
                <TableCell component="th" scope="row">
                  {row?.sr_no}
                </TableCell>
                <TableCell align="right">{row?.required?.join(", ")}</TableCell>
                <TableCell align="right">
                  {row?.lookup_err?.join(", ")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [resData]);

  return (
    <div>
      <Dialog
        onBackdropClick={() => {}}
        keepMounted
        fullWidth={true}
        maxWidth={"sm"}
        TransitionComponent={Transition}
        open={isOpen}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className={styles.DialogWrap}>
          {/*<DialogTitle id="alert-dialog-title">*/}
          <div className={styles.Wrappper}>
            <Typography variant={"subtitle1"}>Upload Product File</Typography>
            <ButtonBase onClick={handleToggle}>
              <CloseIcon />
            </ButtonBase>
          </div>
          {/*</DialogTitle>*/}
          {/* <DialogContent> */}
          <div className={styles.fileWrapp}>
            <File
              clearable
              max_size={10 * 1024 * 1024}
              type={["csv"]}
              fullWidth={true}
              name="image"
              accept={"text/csv"}
              label=""
              default_image={form?.file ? form?.file : null}
              // user_image={form?.image}
              error={errorData?.file}
              // title={'image'}
              value={form?.file}
              // handleChange={this._handleFileChange}
              placeholder={"Upload CSV File"}
              onChange={(file) => {
                LogUtils.log("file", file);
                if (file) {
                  changeTextData(file, "file");
                }
              }}
            />
          </div>

          {/* </DialogContent> */}
          {!isVerified && (
            <div className={styles.printFlex}>
              <PrimaryButton
                disable={isSubmitting}
                onClick={handleSubmit}
                // className={styles.btmBtn}
                variant={"contained"}
                color={"primary"}
              >
                {isSubmitting ? (
                  <CircularProgress color="success" size="20px" />
                ) : (
                  "Verify Csv"
                )}
              </PrimaryButton>
            </div>
          )}

          {isVerified && (
            <div className={styles.printFlex}>
              <PrimaryButton
                disable={isSubmitting}
                onClick={handleSubmit}
                variant={"contained"}
                color={"primary"}
              >
                {isSubmitting ? (
                  <CircularProgress color="success" size="20px" />
                ) : (
                  "Upload Csv"
                )}{" "}
              </PrimaryButton>
            </div>
          )}

          {/*</DialogActions>*/}
          <div className={styles.tableCont}>
            {isSubmitted ? renderTable : ""}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UploadCsvDialog;
